/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsHouseMini: {
  name: 'house-mini';
  data: string;
} = {
  name: 'house-mini',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.32 2.918a.5.5 0 0 0-.64 0l-5 4.166a.5.5 0 0 0-.18.384V13a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V7.468a.5.5 0 0 0-.18-.384l-5-4.166Zm-1.28-.769a1.5 1.5 0 0 1 1.92 0l5 4.167a1.5 1.5 0 0 1 .54 1.152V13a1.5 1.5 0 0 1-1.5 1.5H3A1.5 1.5 0 0 1 1.5 13V7.468a1.5 1.5 0 0 1 .54-1.152l5-4.167Z" fill="currentColor"/></svg>`,
};
